/* eslint-disable no-unused-vars */
import { defineStore } from "pinia";
import http from "../config/apiConfig_sec";

export const useLoginWindowStore = defineStore("loginwindow", {
    actions: {
        async currentWindowFetch() {
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl = "/sec-svc/user/config/allow-login-window";
                    const response = http.get(pathUrl);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },

        async setLoginWindowFetch(payload) {
            const body = {
                userLoginWindow: payload.userLoginWindow,
            };
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl = "/sec-svc/user/config/allow-login-window";
                    const response = http.post(pathUrl, body);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },

    },
});